import { inputForPrintMonthlyScheduleWithDetails } from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintMonthlyScheduleDetailsIn";
import { inputForPrintMonthlySchedule } from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintMonthlyScheduleIn.ts";
import {
  printMonthlySchedule,
  printMonthlyScheduleDetails,
} from "@/pages/human-resources/time-management/endpoints/schedules/print/PrintScheduleEndpoints";
import useDisplayOptionsState from "@/pages/human-resources/time-management/model/display-options/useDisplayOptionsState";
import useVisibleEmployeesSchedules from "@/pages/human-resources/time-management/model/schedule-view/useVisibleEmployeesSchedules";
import useScheduleReferenceData from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceData";
import useSchedulesManager from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useSchedulesManager";
import useScheduleViewFilters from "@/pages/human-resources/time-management/components/display-filters/provider/useScheduleViewFilters.ts";

interface MonthlySchedulePrintRequests {
  print: () => Promise<boolean>;
  printWithDetails: () => Promise<boolean>;
}

export default function usePrintMonthlySchedule(): MonthlySchedulePrintRequests {
  const manager = useSchedulesManager();
  const schedules = useVisibleEmployeesSchedules();
  const displayOptions = useDisplayOptionsState();
  const { state: viewFilters } = useScheduleViewFilters();
  const referenceData = useScheduleReferenceData();
  const visibleTags = referenceData
    .listDailyTags()
    .filter((t) => !displayOptions.selectedDailyTags.shouldHide(t));

  async function print(): Promise<boolean> {
    try {
      const input = inputForPrintMonthlySchedule(
        manager.contractsManager.startDate,
        manager.contractsManager.siteId,
        schedules.map((s) => s.employee.id),
        visibleTags,
        displayOptions,
        viewFilters,
      );
      await printMonthlySchedule(input);
      return true;
    } catch (error) {
      console.error("Failed to print schedule", error);
      return false;
    }
  }

  async function printWithDetails(): Promise<boolean> {
    try {
      const input = inputForPrintMonthlyScheduleWithDetails(
        manager.contractsManager.startDate,
        manager.contractsManager.siteId,
        schedules.map((s) => s.employee.id),
        displayOptions,
        viewFilters,
      );
      await printMonthlyScheduleDetails(input);
      return true;
    } catch (error) {
      console.error("Failed to print schedule", error);
      return false;
    }
  }

  return {
    print,
    printWithDetails,
  };
}
